/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { workforce_CreateVacationBalanceRequest } from '../models/workforce_CreateVacationBalanceRequest';
import type { workforce_VacationBalanceResponse } from '../models/workforce_VacationBalanceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VacationBalancesService {
    /**
     * Create or update a vacation balance
     * Create or update a vacation balance for an employee and year (upsert)
     * @param request Vacation balance data
     * @returns workforce_VacationBalanceResponse Created
     * @throws ApiError
     */
    public static postApiV1VacationBalances(
        request: workforce_CreateVacationBalanceRequest,
    ): CancelablePromise<workforce_VacationBalanceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/vacation-balances',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own vacation balance`,
                500: `Failed to create vacation balance`,
            },
        });
    }
    /**
     * Get vacation balance for an employee
     * Get vacation balance for a specific employee and year
     * @param employeeId Employee ID
     * @param year Calendar year (default: current year)
     * @returns workforce_VacationBalanceResponse OK
     * @throws ApiError
     */
    public static getApiV1VacationBalances(
        employeeId: string,
        year?: number,
    ): CancelablePromise<workforce_VacationBalanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/vacation-balances/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            query: {
                'year': year,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Vacation balance not found`,
                500: `Failed to get vacation balance`,
            },
        });
    }
}
